module.exports = __webpack_public_path__ + "assets/img/btn-download-google-play-9cf2a671.png";